import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { ColorConfigurationSelect } from '../inputs/ColorConfigurationSelect';
import { optionFilterBySystemAndClass } from '../inputs/ConfigurationSelect';
import { PaintColorValue } from '../readonly/PaintColorValue';
import { ConfigurationComponent } from '.';

const SashCoverInput = () => (
  <ColorConfigurationSelect
    configurationKey="sashCoverColor"
    dispatchAction="SET_SASH_COVER"
    optionsFilterFn={optionFilterBySystemAndClass}
  />
);

const config: ConfigurationComponent<'sashCoverColor'> = {
  key: 'sashCoverColor',
  input: <SashCoverInput />,
  display: (value: ConfigurationValues['sashCoverColor']) => (
    <PaintColorValue value={value} />
  ),
};

export default config;
